{
  "kk": {
    "cashback": "{ value } ₸ кешбэк"
  },
  "ru": {
    "cashback": "Кешбэк { value } ₸"
  },
  "en": {
    "cashback": "Cashback { value } ₸"
  }
}
